import React, { useState } from 'react';
import PageFade from "../components/Login/PageFade";
import { HiOutlineExternalLink, HiUserGroup } from "react-icons/hi";
import { MdOutlineVerified, MdOutlineSettingsSuggest } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import closeButton from '../assets/images/close.png';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isRedirecting, setIsRedirecting] = useState(false);

    const handleWebsiteClick = () => {
        setIsRedirecting(true);
        // Professional delay before opening the website
        setTimeout(() => {
            window.open("https://geometricsoft.com/", "_blank", "noopener,noreferrer");
            setIsRedirecting(false);
        }, 1500);
    };

    return (
        <PageFade>
            <div className="font-sans text-white bg-[#f0f4f8]">
                {/* <div className="bg-white shadow-2xl rounded-2xl overflow-hidden border border-gray-200"> */}

                {/* --- Loading Overlay --- */}
                {isRedirecting && (
                    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-slate-900/80 backdrop-blur-sm transition-all duration-500">
                        <div className="w-12 h-12 border-4 border-blue-400 border-t-transparent rounded-full animate-spin mb-4"></div>
                        <h3 className="text-lg text-white font-bold uppercase">Redirecting you to official website...</h3>
                    </div>
                )}

                {/* Header Section - Deep Official Navy */}
                <div className="bg-[#1e293b] text-white p-6 md:p-10 flex justify-between items-center border-b-4 border-blue-700">
                    <div>
                        <h2 className="text-white text-2xl md:text-4xl font-bold tracking-tight uppercase">
                            {t('aboutUs.title')}
                        </h2>
                        <p className="text-blue-400 text-sm md:text-lg mt-1 font-medium opacity-90 tracking-wide">
                            Geometric Infrasoft Technologies LLP
                        </p>
                    </div>
                    <img
                        src={closeButton}
                        alt="close"
                        className="w-8 h-8 cursor-pointer"
                        onClick={() => navigate(-1)}
                    />
                </div>

                <div className="px-8 py-8 md:px-16">
                    {/* Company Core Identity Section */}
                    <section>
                        <div className="space-y-6 text-lg leading-relaxed text-slate-600 font-medium">
                            <p>
                               {t('aboutUs.descriptionLine1')}
                            </p>
                            <p>
                               {t('aboutUs.descriptionLine2')}
                            </p>
                        </div>
                    </section>

                    {/* Call to Action */}
                    <div className="mt-10 flex flex-col items-center">
                        <button
                            onClick={handleWebsiteClick}
                            className="group flex items-center gap-3 px-10 py-4 bg-[#1e293b] text-white rounded-full font-bold hover:bg-blue-800 transition-all shadow-xl hover:shadow-blue-200/50 text-sm tracking-widest cursor-pointer"
                        >
                            Visit Official Website  
                            <HiOutlineExternalLink size={20} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                        </button>
                    </div>
                </div>
            </div>
            {/* </div> */}
        </PageFade>
    );
};

export default AboutUs;